export default __webpack_public_path__ + "static/brainhack-2021-4th-place-e8d91c61d68f13da706d5bb9d7999e89.png";